import type { ReactNode } from 'react';

/** A table-wide message (error, empty) still sits in a row > cell, so the ARIA table stays valid. */
const FullWidthRow = ({ children }: { children: ReactNode }) => (
  <div role="rowgroup">
    <div role="row">
      <div role="cell">{children}</div>
    </div>
  </div>
);

export default FullWidthRow;
